import { createContext } from 'react';

import { TCurrentUserTeamDto } from '@app-velocity/av-api-v2';

export type CurrentTeamContextType = {
  team: TCurrentUserTeamDto | null;
};

export const CurrentTeamContext = createContext<CurrentTeamContextType>({
  team: null,
});
